import React from 'react';
import { Helmet } from 'react-helmet-async';
import './DigitalPolicy.css';

function DigitalPolicy() {
  return (
    <div className="digital-policy-section">
      <Helmet>
        <title>Digital Content Policy | Szakacs Visuals Photography</title>
        <meta name="description" content="Digital content policy for Szakacs Visuals photography services. Learn about our digital delivery, usage rights, and content management policies." />
        <meta name="keywords" content="photography digital policy, digital content rights, Bristol photographer digital delivery, photography usage rights" />
        <meta property="og:title" content="Digital Content Policy | Szakacs Visuals Photography" />
        <meta property="og:description" content="Digital content policy for Szakacs Visuals photography services. Learn about our digital delivery, usage rights, and content management policies." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://szakacsvisuals.co.uk/digital-policy" />
        <link rel="canonical" href="https://szakacsvisuals.co.uk/digital-policy" />
      </Helmet>
      <div className="digital-container">
        <h1>Digital Product Policy</h1>
        <div className="digital-content">
          <div className="business-info">
            <p>Business Name: Szakacs Visuals</p>
          </div>

          <section>
            <p>Welcome to Szakacs Visuals. We value your trust and aim to provide clarity about the terms and conditions associated with purchasing our digital products. By making a purchase, you agree to the following policy:</p>
          </section>

          <section>
            <h2>1. Nature of Digital Products</h2>
            <p>All products sold on this website are digital in nature. This means they are delivered electronically and do not involve any physical shipping. Once a purchase is completed, the product will be available for download or access via the methods specified during the transaction.</p>
          </section>

          <section>
            <h2>2. Delivery of Digital Products</h2>
            <ul>
              <li><strong>Immediate Access:</strong> Upon successful payment, you will receive an email confirmation containing a download link or access instructions for the product.</li>
              <li><strong>Delivery Issues:</strong> If you encounter any issues accessing your purchased product, please contact our support team at szakacs.visuals@gmail.com within 24 hours of purchase.</li>
            </ul>
          </section>

          <section>
            <h2>3. Non-Refundable Policy</h2>
            <p>Due to the nature of digital products, all sales are final and non-refundable.</p>
            <ul>
              <li><strong>No Refunds or Exchanges:</strong> Once a product has been purchased and accessed, it cannot be refunded or exchanged.</li>
              <li><strong>Unauthorized Purchases:</strong> If you believe a purchase was made in error or without your authorization, please contact our support team immediately for assistance.</li>
            </ul>
          </section>

          <section>
            <h2>4. License and Usage</h2>
            <ul>
              <li><strong>Business and Personal Use:</strong> All digital products are licensed for both personal and business use.</li>
              <li><strong>Prohibited Actions:</strong> You may not redistribute, resell, share, or transfer the product to others. Unauthorized distribution or reproduction is a violation of copyright laws.</li>
            </ul>
          </section>

          <section>
            <h2>5. Technical Support</h2>
            <p>We provide limited technical support to ensure you can access and use your purchased digital product. If you experience any issues, please reach out to szakacs.visuals@gmail.com.</p>
          </section>

          <section>
            <h2>6. Updates to Digital Products</h2>
            <p>From time to time, we may update our digital products to improve functionality or address any issues. You will be notified of updates via email if applicable.</p>
          </section>

          <section>
            <h2>7. Limitation of Liability</h2>
            <p>We strive to ensure the quality and functionality of our digital products. However, we are not liable for:</p>
            <ul>
              <li>Incompatibility with your devices or software.</li>
              <li>Issues arising from improper usage of the product.</li>
            </ul>
          </section>

          <section>
            <h2>8. Policy Changes</h2>
            <p>We reserve the right to update this policy at any time. Changes will be posted on this page, and your continued use of our website and services constitutes acceptance of the updated terms.</p>
          </section>

          <section>
            <p>If you have any questions or concerns regarding this policy, please contact us at szakacs.visuals@gmail.com. Thank you for choosing Szakacs Visuals for your digital product needs.</p>
          </section>

          <div className="contact-info">
            <p>Email: szakacs.visuals@gmail.com</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DigitalPolicy; 